var map = {
	"./chat.svg": 5088,
	"./chatgpt-2.svg": 1809,
	"./chatgpt-red.svg": 9975,
	"./chatgpt.svg": 5973,
	"./folder.svg": 2724,
	"./folder2.svg": 1898,
	"./loginRegister.svg": 5676,
	"./loginenter.svg": 7573,
	"./yelllowDuck.svg": 2415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2584;